function getParams (key) {
  if (typeof (this.params) === 'undefined') {
    let url = new URL(location.href)
    this.params = url.searchParams
  }
  return this.params[key]
}

export default {
  methods: {
    getParams: getParams
  }
}
